window.defaultLanguageType = 'en';
window.defaultFromLanguageType = 'en';

function getElementsToBeTranslated (domName, translationObject) {
  var elementsToBeTranslated = $(domName).contents().map(function(){if (this.nodeType == 3 && this.nodeValue.trim() !== "") {return this} })

  elementsToBeTranslated.each(function() {
    translationObject['translatables'].push(this.nodeValue.trim());
  })

  return elementsToBeTranslated;
}

function translate(language_from, language_to, domName='.translate *, .subscription-plan-type, .subscription-plan-type *') {
  console.log("transalting", language_from, language_to, domName);
  var translationObject = {
    'from_language_code': language_from,
    'target_language_code': language_to,
    'translatables' : []
  };

  var elementsToBeTranslated = getElementsToBeTranslated(domName, translationObject);

  $.post(
    window.base_skin_url +"api/translations",
    translationObject
  )
  .done(function( data ) {
    console.log(data);
    elementsToBeTranslated.each(function(id, value){
      this.nodeValue =  data.message[id][translationObject.translatables[id]];
    })
  });

  translatePlaceholder(language_from, language_to);
}

function translatePlaceholder(language_from, language_to){

  var placeholdersToTranslate = $(".placeholder_translate");

  var placeholderTranslationObject = {
    'from_language_code': language_from,
    'target_language_code': language_to,
    'translatables' : placeholdersToTranslate.toArray().map(function(p){ return $(p).attr("placeholder") })
  };

  $.post(
    window.base_skin_url +"api/translations",
    placeholderTranslationObject
  )
  .done(function( data ) {
    console.log(data);
    placeholdersToTranslate.each(function(id, value){ $(value).attr('placeholder', data.message[id][placeholderTranslationObject.translatables[id]]) });
  });
}
